import React, { useState } from 'react';
import _get from 'lodash/get';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import makeGetEntityTypeStatus from 'fetches/makeGetEntityTypeStatus';
import { useData } from 'resift';
import useSyncInfo from 'helpers/useSyncInfo';
import SyncDetails from 'molecules/syncDetails';

interface Props {
  entityTypeId: string;
}

function LastCsvUploadBanner({ entityTypeId }: Props) {
  const classes = useStyles();
  const [isSyncLogOpen, setIsSyncLogOpen] = useState(false);
  const getLastSyncStatus = makeGetEntityTypeStatus(entityTypeId);
  const lastSyncStatusInfo = useData(getLastSyncStatus);

  const syncStatus = _get(lastSyncStatusInfo, ['syncStatus']);
  const { hasSyncErrors, lastSyncDate } = useSyncInfo(syncStatus);

  const toggleViewLog = () => {
    setIsSyncLogOpen(!isSyncLogOpen);
  };

  return (
    <>
      <Paper className={classes.root} elevation={1}>
        <div className={classes.lastUploadLeft}>
          <div className={classes.lastUploadIconContainer}>
            <ArrowUpwardIcon className={classes.lastUploadIcon} />
          </div>
          <span className={classes.rightSpace}>Last CSV Upload:</span>
          {hasSyncErrors && (
            <span className={classes.rightSpace}>
              Attempt <span className={classes.failedText}>Failed</span> at
            </span>
          )}
          <span className={classes.lastUploadDate}>{lastSyncDate}</span>
        </div>
        <Button className={classes.viewLogButton} onClick={toggleViewLog}>
          View Log
        </Button>
      </Paper>
      <SyncDetails
        syncStatus={_get(lastSyncStatusInfo, ['syncStatus'])}
        open={isSyncLogOpen}
        onClose={toggleViewLog}
      />
    </>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    ...theme.typography.body2,
    width: '100%',
    minHeight: 68,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
  },
  lastUploadLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  lastUploadIconContainer: {
    width: 24,
    height: 24,
    borderRadius: 6,
    backgroundColor: theme.palette.secondary.light,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(),
  },
  lastUploadIcon: {
    color: theme.palette.common.white,
    fontSize: 12,
  },
  rightSpace: {
    marginRight: theme.spacing(0.5),
  },
  lastUploadDate: {
    color: theme.palette.text.secondary,
  },
  viewLogButton: {
    color: theme.palette.secondary.main,
    textAlign: 'right',
    minWidth: 'auto',
  },
  failedText: {
    color: theme.palette.error.main,
  },
}));

export default LastCsvUploadBanner;
